
export enum SettingKey {
  UXDefaultRoute = "UX.Route.Default",
  UXDefaultRouteActivityThreshold = "UX.Route.Default.ActivityThreshold.Seconds",
  UXShowL4LChangedNotifications = "UX.Notifications.L4LChanged",
  UXComponentActionsEnabled = "UX.Component.Actions.Enabled"
}
